export { default as getVdirHandler } from './getVdirHandler';
export { default as isRouteRegistrationWithAppEnabled } from './isRouteRegistrationWithAppEnabled';
export {
    MAIL_APP_NAME,
    CALENDAR_APP_NAME,
    FILES_APP_NAME,
    PEOPLE_APP_NAME,
} from './appNameConstants';
